/**
 * Client constants for WalletConnect Pay SDK
 */

/** Default Pay API base URL */
export const PAY_API_BASE_URL = "https://api.pay.walletconnect.com";

/** SDK name for tracking */
export const SDK_NAME = "js-walletconnect-pay";

/** SDK version (from package.json) */
export const SDK_VERSION = `1.0.9`;

/** Client context name */
export const CLIENT_CONTEXT = "pay";

/** Logger context */
export const LOGGER_CONTEXT = "WalletConnectPay";
